import { render, staticRenderFns } from "./portal.vue?vue&type=template&id=350c4cdc&scoped=true&"
import script from "./portal.vue?vue&type=script&lang=js&"
export * from "./portal.vue?vue&type=script&lang=js&"
import style0 from "./portal.vue?vue&type=style&index=0&id=350c4cdc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "350c4cdc",
  null
  
)

export default component.exports